import { memo } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

import User from '../../user';
import { NavigationButton, BalanceInfo } from './items';
import { HEIGHT_OF_MOBILE_HEAD } from '../../../../consts';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: HEIGHT_OF_MOBILE_HEAD,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 3)
  }
}));

const MobileHeader = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <NavigationButton />
      <BalanceInfo />
      <User />
    </Box>
  );
};

export default memo(MobileHeader);
